<template>
  <va-navbar class="app-navbar">
    <header-selector slot="selector" :minimized.sync="minimizedProxy" />
      <div class="logo-easy-navbar">
        <img src="../../../assets/images/logo-easypallet-white.png" class="logo">
      </div>

      <div class="app-navbar__actions row flex-nowrap align--center" :style="cssVars">
        <template>
          <va-dropdown
            class="notification-dropdown"
            offset="0, 16px"
            boundary-body
          >
            <va-icon
              slot="anchor"
              name="i-nav-notification"
              class="notification-dropdown__icon"
              :class="{'notification-dropdown__icon--unread': !allRead}"
            />
            <div class="notification-dropdown__content pl-3 pr-3 pt-2 pb-2">
              <div
                v-for="option in this.options"
                :key="option.id"
                class="notification-dropdown__item row pt-1 pb-1 mt-2 mb-2"
                :class="{'notification-dropdown__item--unread': option.unread}"
                @click="markAsRead(option.id)"
              >
              <span class="ellipsis" style="max-width: 98%;">
                {{$t(`${option.message}`)}}
              </span>
              </div>
              <div class="row justify--space-between">
                <va-button class="ma-0 mb-2 mt-1" small :color="this.$themes.secondary" @click="last10Read">{{ $t('tables.notifications.last_10_read') }}</va-button>
                <va-button class="ma-0 mb-2 mt-1" small :color="this.$themes.secondary" outline @click="markAllAsRead" :disabled="allRead">{{ $t('tables.notifications.mark_all_read') }}</va-button>
              </div>
            </div>
          </va-dropdown>
        </template>

        <locality-dropdown class="va-navbar__item" />

        <profile-dropdown class="va-navbar__item">
          <span icon="github" class="userLogin">{{ `${currentUser.login}@${currentUser.company}` }}</span>
          <va-icon name="fa fa-user" size="12px" class="ml-2"/>
        </profile-dropdown>

        <language-dropdown class="va-navbar__item" />
      </div>
  </va-navbar>
</template>

<script>
import VaIconVuestic from 'vuestic-ui/src/components/vuestic-components/va-icon/va-iconset/VaIconVuestic'
import HeaderSelector from './components/HeaderSelector'
import LanguageDropdown from './components/dropdowns/LanguageDropdown'
import LocalityDropdown from './components/dropdowns/LocalityDropdown'
import ProfileDropdown from './components/dropdowns/ProfileDropdown'
import NotificationDropdown from './components/dropdowns/NotificationDropdown'
import MessageDropdown from './components/dropdowns/MessageDropdown'
import SettingsDropdown from './components/dropdowns/SettingsDropdown'
import ColorDropdown from './components/dropdowns/ColorDropdown'
import { mapState } from 'vuex'
import NotificationAPI from '@/services/NotificationAPI'

export default {
  name: 'app-navbar',
  components: {
    SettingsDropdown,
    ColorDropdown,
    VaIconVuestic,
    HeaderSelector,
    MessageDropdown,
    NotificationDropdown,
    LanguageDropdown,
    LocalityDropdown,
    ProfileDropdown,
  },
  props: {
    minimized: {
      type: Boolean,
      required: true,
    },

  },
  data () {
    return {
      refreshInterval: null,
      userName: 'Administrador',
      options: [],
    }
  },

  mounted () {
    if ((this.currentUser.user_id !== undefined) && ((this.currentLocality.id !== null) || (this.currentLocality.id !== undefined))) {
      this.refreshInterval = setInterval(() => {
        this.readItems()
      }, 10000)
    }
  },

  beforeDestroy () {
    clearInterval(this.refreshInterval)
  },

  computed: {
    ...mapState(['currentUser', 'currentLocality']),

    cssVars () {
      return {
        '--secondary-color': this.$themes.secondary,
        '--primary-color': this.$themes.primary,
      }
    },

    minimizedProxy: {
      get () {
        return this.minimized
      },
      set (minimized) {
        this.$emit('update:minimized', minimized)
      },
    },

    allRead () {
      return !this.options.filter(item => item.unread).length
    },
  },
  methods: {
    async readItems () {
      await NotificationAPI.getUnread(this.currentLocality.id).then(response => {
        this.options = response.data.notifications
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
    },

    markAllAsRead () {
      NotificationAPI.markAllRead(this.currentLocality.id).then(response => {
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })

      this.options.forEach(item => {
        item.unread = false
      })
    },

    markAsRead (notificationId) {
      NotificationAPI.markAsRead(notificationId).then(response => {
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })

      this.options.forEach(item => {
        if (item.id === notificationId) {
          item.unread = false
        }
      })
    },

    last10Read () {
      NotificationAPI.last10Read(this.currentLocality.id).then(response => {
        this.options = response.data.notifications
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
    },

  },
}
</script>
<style lang="scss">
  .app-navbar {
    &__button {
      width: 10.8125rem;
      .va-button__content__icon-left.fa-github {
        font-size: 1.5rem;
      }
    }
    &__actions {
      justify-content: flex-end;
    }
    &__mailto-link:hover {
      filter: brightness(85%);
    }
    @include media-breakpoint-down(lg) {
      &__button {
        display: none !important;
      }
      .profile-dropdown {
        margin: auto 0 auto 0.75rem;
      }
    }
    @include media-breakpoint-down(md) {
      @at-root .va-navbar__text {
        display: none !important;
      }
    }
    @include media-breakpoint-down(sm) {
      &__button {
        display: none !important;
      }
      &__actions {
        justify-content: space-around;
        padding: 0 0.5rem;
      }
      .profile-dropdown {
        position: absolute;
        right: 0.60rem;
        top: 1.25rem;
        height: fit-content;
        margin: auto;
      }
      .locality-dropdown {
        position: absolute;
        right: 1.00rem;
        bottom: 1.25rem;
        height: fit-content;
        margin: auto;
      }
      .language-dropdown {
        position: absolute;
        left: 1.00rem;
        bottom: 1.00rem;
        height: fit-content;
        margin: auto;
      }
      .logo-easy-navbar {
        position: absolute;
        left: 3.00rem;
        top: 0.75rem;
        height: fit-content;
        margin: auto;
        width: 80px;
      }
    }

    .logo {
      position: relative;
      width: 120px;
      margin-right: 500px;
      margin-left: 10px;
      margin-bottom: -5px;
    }

    .userLogin {
      color: #FFF;
    }
    .logo-user {
      width: 0.625em;
      margin-left: 8px;
    }
  }

  .notification-dropdown {
  cursor: pointer;
  margin-top: 0.3rem;

  .notification-dropdown__icon {
    position: relative;
    display: flex;
    align-items: center;

    &--unread::before {
      content: '';
      position: absolute;
      right: 0;
      left: 0;
      top: -.5rem;
      background-color: var(--primary-color);
      height: .375rem;
      width: .375rem;
      margin: 0 auto;
      border-radius: .187rem;
    }
  }

  &__content {
    background-color: $dropdown-background;
    box-shadow: $gray-box-shadow;
    border-radius: .5rem;
    width: 35rem;
    max-width: 90%;
  }

  &__item {
    cursor: pointer;
    margin-bottom: .75rem;
    color: $brand-secondary;
    flex-wrap: nowrap;
    position: relative;

    &--unread {
      color: $vue-darkest-blue;

      &:after {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        height: .375rem;
        width: .375rem;
        background-color: $brand-danger;
        margin: auto;
        border-radius: .187rem;
      }
    }

    &:hover {
      color: var(--secondary-color)
    }

  }

  .va-dropdown__anchor {
    display: inline-block;
  }
}
</style>
